import React, { useMemo, useState } from 'react';
import type { CreateMovementPayload, CashMovementType } from '../../types/cash';

export function CashDrawerMovementModal(props: {
  open: boolean;
  onClose: () => void;
  defaultDate: string;
  defaultPosId?: string;
  onSubmit: (p: CreateMovementPayload) => Promise<void>;
}) {
  const [type, setType] = useState<CashMovementType>('OUT');
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const movementDate = useMemo(() => `${props.defaultDate}T12:00:00.000Z`, [props.defaultDate]);

  if (!props.open) return null;

  async function submit() {
    const n = Number(amount.replace(',', '.'));
    if (!Number.isFinite(n) || n <= 0) return;

    setSaving(true);
    try {
      await props.onSubmit({
        movementDate,
        posId: props.defaultPosId,
        type,
        amount: n,
        reason: reason || undefined,
        note: note || undefined,
      });
      setAmount('');
      setReason('');
      setNote('');
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        onMouseDown={props.onClose}
      >
        <div className="modal-dialog modal-dialog-centered" onMouseDown={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nuovo movimento cassetto</h5>
              <button type="button" className="btn-close" onClick={props.onClose} />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Tipo</label>
                <select className="form-select" value={type} onChange={(e) => setType(e.target.value as CashMovementType)}>
                  <option value="IN">IN (entrata)</option>
                  <option value="OUT">OUT (uscita)</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Importo</label>
                <input
                  className="form-control"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="es. 50"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Causale</label>
                <input
                  className="form-control"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="es. Prelievo banca"
                />
              </div>

              <div className="mb-0">
                <label className="form-label">Note</label>
                <textarea className="form-control" rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-outline-secondary" onClick={props.onClose} disabled={saving}>
                Annulla
              </button>
              <button className="btn btn-primary" onClick={submit} disabled={saving}>
                {saving ? 'Salvo…' : 'Salva'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}